import { render } from "./UserTransfersTableMobile.vue?vue&type=template&id=5e3a6105&scoped=true"
import script from "./UserTransfersTableMobile.vue?vue&type=script&lang=js"
export * from "./UserTransfersTableMobile.vue?vue&type=script&lang=js"

import "./UserTransfersTableMobile.vue?vue&type=style&index=0&id=5e3a6105&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3a6105"]])

export default __exports__